/**
 * Fallback constants for when the chat service is unavailable
 * These are used when the chat-config API fails to load
 */

import { brand } from '../../app/colors';

// Default message shown when AI service is unavailable
export const FALLBACK_SERVICE_MESSAGE =
  "We're having trouble loading the assistant right now. Please try again in a few minutes.";

// Default agent name when config fails to load
export const FALLBACK_AGENT_NAME = 'Assistant';

// Default theme colors when config fails to load - use centralized brand colors
export const FALLBACK_THEME = {
  primary: brand.primary,
  secondary: brand.secondary,
};
